<div class="col-12 w-100 p-0">
    <mat-select [formControl]="id" class="sell" SelectUi (selectionChange)="selectCat($event.value)">
        <mat-option [value]="i.id" *ngFor="let i of shootCat.items;">{{i?.name || 'N/a'}}</mat-option>
    </mat-select>
    <div class="append flex">
        <img *ngIf="!shootCat?.isLoading" src="assets/svg/filter-down.svg">
        <i class="fa fa-spinner fa-spin" *ngIf="shootCat?.isLoading"></i>
    </div>
</div>